import _ from "underscore";
import Product from "@system/config/product";
import store from "../../storeWire";
import Helper from "src/helper/Helper";
import Constants from "src/helper/Constants";
import System from "src/helper/system";

const { Distributor: { AVNET, FLIP, NEWARK, ROCHESTER, WALDOM }, siteUser: { CORE } } = Constants

class ResponseMaker {
    data = {};
    keyConfig = {};
    Count = 0;
    facets = {};
    flagFacets = [];
    processed_payload = {
        value: []
    };

    constructor(data = false) {
        if (data !== false) {
            this.data = data;
            if (this?.data?.data?.Products) {
                this.data.data.products = this.data.data.Products;
            }
        }
    }

    process = () => {
        return this;
    };

    run = (axios_config = false, raw_config = false) => {
        let categoryFilter_detected = store.getState().entities.model_ProductListing.category_filter_applied_status;
        const toBoolean = (value) => ['Yes', 'Y', true, '1', 1].includes(value);
        const trimOrEmpty = (value) => (value && value.trim()) || ''
        let appendFacadeOptions_detected = false;
        if (raw_config?.p_filter?.appendFacadeOptions_detected !== undefined) {
            appendFacadeOptions_detected = raw_config.p_filter.appendFacadeOptions_detected;
        }

        let value = [];
        if (this.data?.data?.products && this.data.data.products.length > 0) {
            this.data.data.products.map((v, i) => {
                let here_v = {
                    Attributes: v.Attributes,
                    CustomerPartNumbers: System.avUserInfoData.currentUser === CORE ? v.CustomerPartNumbers ? v.CustomerPartNumbers : [] : [],
                    DesignIds: v.DesignIds,
                    DesignWinFlag: v.DesignWinFlag,
                    ECCNCode: v.ECCNCode,
                    ERPMFRPartNumber: v.ERPMFRPartNumber,
                    ERPManufacturerCode: v.ERPManufacturerCode,
                    ERPManufacturerName: v.ERPManufacturerName,
                    ERPPartNumber: trimOrEmpty(v.ERPPartNumber),
                    ERPSupplierCode: v.ERPSupplierCode, // added By Ramya
                    EndOfLifeFlag: toBoolean(v.EndofLifeFlag),
                    FactoryLeadTime: v.FactoryLeadTime,
                    FamilyName: v.FamilyName,
                    ExcessInventoryFlag: toBoolean(v.ExcessInventoryFlag),
                    FranchiseFlag: v.FranchiseFlag,
                    GreenCompliantFlag: v.GreenCompliantFlag,
                    HTSCode: v.HTSCode,
                    HazardousFlag: toBoolean(v.HazardousFlag),
                    ITARFlag: v.ITARFlag,
                    IsDesignsAvailable: v.IsDesignsAvailable,
                    ItemNumber: v.ItemNumber,
                    ItemRowNumber: v.ItemRowNumber,
                    Instock: v.Instock,
                    Level_1_Name: v.Level_1_Name,
                    Level_1_URL: v.Level_1_URL,
                    Level_2_Name: v.Level_2_Name,
                    Level_2_URL: v.Level_2_URL,
                    Level_3_Name: v.Level_3_Name,
                    Level_3_URL: v.Level_3_URL,
                    Level_4_Name: v.Level_4_Name,
                    Level_4_URL: v.Level_4_URL,
                    LifeCycleRisk: v.LifeCycleRisk,
                    LongDescription: v.LongDescription,
                    ManufacturerCode: v.ManufacturerCode,
                    // ManufacturerDatasheetURL: v.ManufacturerDatasheetURL,
                    ManufacturerLogo: v.ManufacturerLogo,
                    ManufacturerName: v.ManufacturerName,
                    ManufacturerPartNumber: v.ManufacturerPartNumber,
                    NCNRFlag: toBoolean(v.NCNRFlag),
                    NPIFlag: toBoolean(v.NPIFlag),
                    ObsoleteFlag: toBoolean(v.ObsoleteFlag),
                    ProductFeatures: v.ProductFeatures,
                    QtyMin: v.QtyMin,
                    QtyMult: v.QtyMult,
                    ROHSCompliantCode: v.ROHSCompliantCode,
                    ROHSCompliantCodeValue: v.ROHSCompliantCodeValue,
                    SAPMatgroup: v.SAPMatgroup,
                    SalesOrg: v.SalesOrg,
                    Sboat: v.Sboat,
                    ScheduleBCode: v.ScheduleBCode,
                    ShortDescription: trimOrEmpty(v.ShortDescription),
                    SoftwareDownloadFlag: toBoolean(v.SoftwareDownloadFlag),
                    SoftwareFlag: v.SoftwareFlag,
                    Stock: v.Stock,
                    StructureHierarchy: v.StructureHierarchy,
                    sapTlaTypeCd: v.sap_tla_type_cd,
                    ThumbnailPath: v.ThumbnailPath,
                    TopSellerFlag: toBoolean(v.TopSellerFlag),
                    VendorCode: v.VendorCode,
                    VendorPartNumber: v.VendorPartNumber,
                    WebCode: v.WebCode,
                    WebOnlyFlag: toBoolean(v.WebOnlyFlag),
                    categoryListing: v.categoryListing || [],
                    dynamic_columns: v.dynamic_columns || {},
                    // Datasheet: trimOrEmpty(v.ManufacturerDatasheetURL),
                    DatasheetUrl: trimOrEmpty(v.IHSManufacturerDatasheetURL) || trimOrEmpty(v.ManufacturerDatasheetURL),
                    AssetURL: trimOrEmpty(v.AssetURL),
                    ImagePath: trimOrEmpty(v.ImagePath),
                    TopProducts: v.TopProducts ? v.TopProducts.slice(0, 4) : [],
                    SapPartNumber: v.SapPartNumber,
                    country_of_origin: v.country_of_origin?.trim(),
                    PIMBlock: v.PIMBlock,
                    SAPMaterialPricingGroupCode: v.SAPMaterialPricingGroupCode,
                    UNSPSCVersionCode: trimOrEmpty(v.UNSPSCVersionCode),
                    UNSPSCCode: trimOrEmpty(v.UNSPSCCode),
                    default_plant: v.default_plant ? v.default_plant : "",
                    exists_in_sap: v.exists_in_sap ? true : false,
                    factory_qoh: v.factory_qoh ? parseInt(v.factory_qoh) : 0,
                    MDMMaterialID: v.MDMMaterialID ? v.MDMMaterialID : "",
                    distributor: v.distributor ? v.distributor : AVNET,
                    AllocationFlag: toBoolean(v.AllocationFlag),
                    PackagingTypeCode: v.PackagingTypeCode ? v.PackagingTypeCode : "",
                    Prop65Flag: toBoolean(v.Prop65Flag),
                    IsTariffEligible: toBoolean(v.IsTariffEligible),
                    custom_reel_flag: toBoolean(v.custom_reel_flag),
                    AliasPartNumberSecondarySupplier: v.AliasPartNumberSecondarySupplier ? v.AliasPartNumberSecondarySupplier : null,
                    sap_originating_countryoforigin: v.sap_originating_countryoforigin,
                    SEOERPMFRPartNumber: v.SEOERPMFRPartNumber,
                    SEOManufacturerName: v.SEOManufacturerName,
                    Published: toBoolean(v.Published)
                }

                if (here_v?.SAPMaterialPricingGroupCode?.toUpperCase() === 'SP' || here_v?.SAPMaterialPricingGroupCode?.toUpperCase() === 'EI') {
                    // Helper.alert('special pricing part')
                    // console.log('special pricing part', here_v.ERPMFRPartNumber)
                    here_v.specialPriceFlag = true
                }

                if (here_v?.SAPMaterialPricingGroupCode?.toUpperCase() === 'CP') {
                    // Helper.alert('constraint part')
                    // console.log('constraint part', here_v.ERPMFRPartNumber)
                    here_v.constrainPartFlag = true
                }

                if (here_v.ROHSCompliantCode !== undefined) {
                    here_v.ROHSCompliantCodeValue = Product.product__ROHSCompliantCode(here_v.ROHSCompliantCode);
                } else {
                    here_v.ROHSCompliantCodeValue = false;
                }

                if (here_v.Instock === 'No' || here_v.Instock === 'N' || here_v.Instock === null) {
                    here_v.Instock = false;
                    here_v.Stock = 0
                } else if (here_v.Instock === 'Yes' || here_v.Instock === 'Y') {
                    here_v.Instock = true;
                }

                if (here_v.distributor === AVNET) {
                    here_v.isAvnetDistributor = true
                } else if (here_v.distributor === FLIP || here_v.distributor === ROCHESTER || here_v.distributor === WALDOM) {
                    here_v.isPartnerDistributor = true
                } else if (here_v.distributor === NEWARK) {
                    here_v.isNewarkDistributor = true
                }

                here_v.categoryListing = [];
                if (here_v.Level_1_Name && here_v.Level_1_URL) {
                    here_v.categoryListing.push({
                        value: here_v.Level_1_Name,
                        level: 2,
                        url: here_v.Level_1_URL
                    })
                }
                if (here_v.Level_2_Name && here_v.Level_2_URL) {
                    here_v.categoryListing.push({
                        value: here_v.Level_2_Name,
                        level: 2,
                        url: here_v.Level_2_URL
                    })
                }
                if (here_v.Level_3_Name && here_v.Level_3_URL) {
                    here_v.categoryListing.push({
                        value: here_v.Level_3_Name,
                        level: 3,
                        url: here_v.Level_3_URL
                    })
                }
                if (here_v.Level_4_Name && here_v.Level_4_URL) {
                    here_v.categoryListing.push({
                        value: here_v.Level_4_Name,
                        level: 4,
                        url: here_v.Level_4_URL
                    })
                }

                if (here_v.ERPPartNumber) {
                    if ((this.data.data.products).filter(f => f.ERPPartNumber === here_v.ERPPartNumber).length > 1) {
                        Helper.alert("same erpPartNumber ")
                    }
                } else {
                    console.log(here_v.ItemNumber, here_v.ERPMFRPartNumber)
                    Helper.alert("No erpPartNumber ")
                }
                if (here_v.CustomerPartNumbers && here_v.CustomerPartNumbers.length > 0) {

                    // if(here_v.CustomerPartNumbers.length === 1){
                    //     here_v.CPN = here_v.CustomerPartNumbers[0]?.CPN
                    // }
                    const shipTo = System.getUserShippingAddress();
                    here_v.CustomerPartNumbers = here_v.CustomerPartNumbers.filter(f => f.SHP === shipTo || !f.SHP)
                    const testCpn = here_v.CustomerPartNumbers.filter(f => f.SHP !== null && f.SHP !== undefined && f.SHP !== "")
                    if (testCpn.length) {
                        console.log("shp ", testCpn)
                        Helper.alert("I have CPN Ship to")
                    }
                }

                value[i] = here_v;
            })
        }
        this.processed_payload.value = value;

        if (this.data && this.data.data) {
            if (this.data.data.Count !== undefined) {
                this.Count = this.data.data.Count;
            }

            if (this.data.data.Categories) {
                this.facets['Categories'] = this.processCategories(this.data.data.Categories);
            }

            if (this.data.data.Documents !== undefined) {
                this.facets['Documents'] = this.processDocuments(this.data.data.Documents.webContentView);
            }

            if (this.data.data.Manufacturer !== undefined) {
                this.facets['ManufacturerName'] = this.processManufacturerName(this.data.data.Manufacturer);
            }
            if (this.data.data.ProductFamily !== undefined) {
                this.facets['FamilyName'] = this.processFamilyName(this.data.data.ProductFamily);
            }
            if (this.data.data.FlagFacets !== undefined) {
                this.flagFacets = this.processFlagFacets(this.data.data.FlagFacets);
            }
            if (categoryFilter_detected !== false && this.data.data.Attributes !== undefined) {
                this.facets['Attributes'] = this.processAttributes(this.data.data.Attributes);
            }
            if (appendFacadeOptions_detected !== false && this.data.data.Attributes !== undefined) {
                this.facets['Attributes'] = this.processAttributesForAppendFacadeOptionFlag(this.data.data.Attributes);
            }
        }

        if (this.facets['Attributes'] && Object.entries(this.facets['Attributes']) &&
            Object.entries(this.facets['Attributes']['Attributes']) &&
            Object.entries(this.facets['Attributes']['Attributes']).length > 0) {
            this.facets['Attributes']['Attributes'].map((v, i) => {
                let v_here = { ...v };
                let slug = Helper.anythingToCamel(v.value);
                let v_here_Attributes = v.Attributes;
                delete v_here.Attributes;
                this.facets[slug] = {
                    ...v_here,
                    slug: slug,
                    main_label: v_here.name,
                    [slug]: v_here_Attributes
                };
            });
        }
        if (this.processed_payload.value) {
            this.processed_payload.value = this.makeDynamicColumns(this.processed_payload.value);
        }
        return this;
    };

    get = () => {
        return {
            value: this.processed_payload.value,
            productCount: this.Count,
            searchFacets: this.facets,
            flagFacets: this.flagFacets
        };
    };

    processAttributesForAppendFacadeOptionFlag = (processAttributes = {}) => {
        let a_main = this.processAttributes(processAttributes);
        let e = store.getState().entities;
        let a = Object.entries(e.ProductListingFilterApplied);
        if (a_main.Attributes !== undefined && a.length) {
            let a_b = {}
            a.map((v) => {
                a_b[v[1].main_label] = v;
            });
            a_main.Attributes.map((v, i) => {
                if (a_b[v.main_label] === undefined) {
                    delete a_main.Attributes[i];
                }
            })
        }
        return a_main;
    };

    processAttributes = (processAttributes = {}) => {
        let f = [];
        let count = 0;
        if (processAttributes && Object.entries(processAttributes).length > 0) {
            Object.entries(processAttributes).map((v, i) => {
                let v_list = this.processFacets(v[1]);
                let v_count = 0;
                v_list.map((v, i) => {
                    v_count = v_count + v.count;
                });
                f.push({
                    value: v[0],
                    main_label: v[0],
                    name: v[0],
                    Attributes: v_list,
                    count: v_count
                });
                count = count + v_count;
            });
        }
        return {
            Attributes: f,
            count,
            slug: 'Attributes',
            main_label: 'Attributes',
        };
    };
    processFamilyName = (processAttributes = {}) => {
        let f = this.processFacets(processAttributes);
        let count = 0;
        if (f.length > 0) {
            f.map((v) => {
                count = count + v.count
            })
        }
        return {
            FamilyName: f,
            count,
            slug: 'FamilyName',
            main_label: 'Product Family',
        };
    };
    processFlagFacets = (processFlagFacets = {}) => {
        let f = [];
        let count = 0;
        if (processFlagFacets && processFlagFacets.length > 0) {
            processFlagFacets.map((v, i) => {
                f[i] = {
                    ...v,
                    value: v.Value,
                    key: v.Key,
                    main_label: v.Description,
                    name: v.Description,
                    Name: v.Description,
                    slug: v.Value,
                    count: v.Count
                };
                count = count + v.Count;
            });
        }
        return {
            slug: 'flagFacets',
            main_label: 'Flag Facets',
            value: 'Flag Facets',
            count: count,
            flagFacets: f
        };
    };
    makeDynamicColumns = (value) => {
        let v_f = [];
        if (value && value.length > 0) {
            value.map((v) => {
                let v_h = v;
                let dynamic_columns = {};
                if (v_h.Attributes && _.isArray(v_h.Attributes) && v_h.Attributes.length > 0) {
                    v_h.Attributes.map((v) => {
                        let field = Helper.anythingToCamel(v.ATTRNAME);
                        let search_type = System.getFieldType(field);
                        if (search_type === Constants.CognitiveSearchFieldConfig.attributes) {
                            dynamic_columns[field] = v.ATTRVAL
                        }
                    })
                }
                v_h.dynamic_columns = dynamic_columns;
                v_f.push(v_h)
            })
        }
        return v_f;
    };

    processManufacturerName = (processAttributes = {}) => {
        let f = this.processFacets(processAttributes);
        let count = 0;
        if (f.length > 0) {
            f.map((v) => {
                count = count + v.count
            })
        }
        return {
            ManufacturerName: f,
            count,
            slug: 'ManufacturerName',
            main_label: 'Manufacturer',
        };
    };

    processCategories = (processCategories = {}) => {
        let f = [];
        let count = 0;
        if (processCategories && Object.entries(processCategories).length > 0) {
            processCategories = this.processFacets(processCategories);
            processCategories.map((v, i) => {
                let here = {
                    value: v.value,
                    main_label: v.value,
                    Name: v.value,
                    count: v.count
                };
                if (v.Level !== undefined) {
                    here.Level = v.Level;
                }
                if (v.Url !== undefined) {
                    here.Url = v.Url;
                }
                if (v.Categories && v.Categories.length) {
                    let inner_res = this.processCategories(v.Categories);
                    here.Categories = inner_res.Categories;
                }
                count = here.count;
                f.push(here);
            });
        }
        return {
            Categories: f,
            count,
            slug: 'Categories',
            main_label: 'Category',
        };
    };


    processDocuments = (processDocuments = {}) => {
        let f = [];
        let count = 0;
        if (processDocuments && processDocuments.length > 0) {
            processDocuments.map((v, i) => {

                if (v.name) {
                    let here = {};
                    here.name = v.name;
                    if (v.Manufacturer) {
                        here.manufacturer = v.Manufacturer;
                    }
                    if (v.url) {
                        here.url = v.url;
                    }
                    if (v.MediaType) {
                        here.mediaType = v.MediaType;
                    }
                    count = processDocuments.length;
                    f.push(here);
                }
            });
        }
        return {
            Documents: f,
            count,
            slug: 'Documents',
            main_label: 'Documents',
        };
    };


    processFacets = (facets = []) => {
        let f = [];
        if (facets && facets.length > 0) {
            facets.map((v, i) => {
                f[i] = {
                    ...v,
                    value: v.Name,
                    main_label: v.Name,
                    count: v.Count
                }
            });
        }
        return f;
    };
}

export default ResponseMaker;